<script>
export default {
  name: 'SelectionLot',
  props: {
    value: {
      type: Object,
      default: null
    },
    lots: {
      type: Array,
      required: true
    }
  },
  data: () => ({
    lot: null,
    typesLots: {
      'OL': 'Volaille ponte',
      'VL': 'Volaille chair'
    }
  }),
  computed: {
    _lots () {
      return this.lots.slice().sort((a, b) => {
        const typeA = a.numLot.slice(0, 2);
        const typeB = b.numLot.slice(0, 2);
        if (typeA === typeB) {
          return (a.dateMep || '').localeCompare(b.dateMep);
        } else {
          return typeA.localeCompare(typeB);
        }
      });
    }
  },
  watch: {
    value () {
      this.lot = this.value;
    }
  },
  created () {
    this.lot = this.value;
  },
  methods: {
    selectLot (lot) {
      this.lot = lot;
      this.updateValue();
    },
    clearLot () {
      this.lot = null;
      this.updateValue();
    },
    updateValue () {
      this.$emit('input', this.lot);
    },
    isSameTypeLot (lot1, lot2) {
      if (!lot1 || !lot2) {
        return true;
      }

      const typeA = lot1.numLot.slice(0, 2);
      const typeB = lot2.numLot.slice(0, 2);

      return typeA === typeB;
    }
  }
};
</script>

<template>
  <div v-if="!lots">
    Erreur liste lots
  </div>
  <div v-else-if="lots.length === 0">
    Vous n’avez aucun lot de volaille actuellement en place
  </div>
  <div
    v-else-if="lot === null"
    class="selection"
  >
    <table
      v-if="!isMobile"
      class="list-lots"
    >
      <thead>
        <tr>
          <th class="header">
            Exploitation
          </th>
          <th class="header">
            Batiment
          </th>
          <th class="header">
            Lot
          </th>
          <th class="header">
            Date de mise en place
          </th>
          <th />
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(_lot, index) in _lots"
          :key="_lot.numLot"
          :class="{'pad-top':!isSameTypeLot(_lot, _lots[index-1])}"
        >
          <td class="line">
            <RefValue
              :code="_lot.numExploitation"
              type="EXPLOITATION"
            />
          </td>
          <td class="line">
            {{ _lot.numBatiment }}
          </td>
          <td class="line">
            {{ _lot.numLot }}
          </td>
          <td class="line">
            {{ _lot.dateMep | date }}
          </td>
          <td
            class="line"
            style="width:120px;text-align:right"
          >
            <v-btn
              color="secondary"
              @click="selectLot(_lot)"
            >
              Voir
            </v-btn>
          </td>
        </tr>
      </tbody>
    </table>
    <div
      v-else
      class="liste-lots-mobile"
    >
      <v-card
        v-for="(_lot, index) in _lots"
        :key="_lot.numLot"
        :class="{'pad-top':!isSameTypeLot(_lot, _lots[index-1])}"
        @click="selectLot(_lot)"
      >
        <div class="card-row">
          <div>
            <div class="header">
              Exploitation
            </div>
            <div class="line">
              <RefValue
                :code="_lot.numExploitation"
                type="EXPLOITATION"
              />
            </div>
          </div>
        </div>
        <div class="card-row">
          <div>
            <div class="header">
              Batiment
            </div>
            <div class="line">
              {{ _lot.numBatiment }}
            </div>
          </div>
          <div>
            <div class="header">
              Lot
            </div>
            <div class="line">
              {{ _lot.numLot }}
            </div>
          </div>
          <div>
            <div class="header">
              Date de mise en place
            </div>
            <div class="line">
              {{ _lot.dateMep | date }}
            </div>
          </div>
        </div>
      </v-card>
    </div>
  </div>
  <div
    v-else
    class="selected"
  >
    <v-btn
      color="grey"
      outlined
      @click="clearLot()"
    >
      <v-icon>mdi-arrow-left</v-icon>
      Liste des lots
    </v-btn>
    <div
      class="d-flex flex-row"
      :class="{'mx-6 my-6':!isMobile}"
    >
      <CardsHelp
        :page="'DETAIL-LOT'"
        :niveau="'SOUS-TITRE'"
        class="mr-5"
      />
      <v-avatar
        color="secondary"
        size="56"
        class="mr-4"
      >
        <span class="white--text">

          <v-icon
            size="25"
            color="white"
          >
            $vuetify.icons.chicken
          </v-icon>
          <span style="font-size:12px;">
            {{ lot.nbAnimaux }}
          </span>
        </span>
      </v-avatar>
      <div class="selected-lot">
        <table v-if="!isMobile">
          <thead>
            <tr>
              <th class="header">
                Exploitation
              </th>
              <th class="header">
                Batiment
              </th>
              <th class="header">
                Lot
              </th>
              <th class="header">
                Date de mise en place
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <RefValue
                  :code="lot.numExploitation"
                  type="EXPLOITATION"
                />
              </td>
              <td>{{ lot.numBatiment }}</td>
              <td>{{ lot.numLot }}</td>
              <td>{{ lot.dateMep | date }}</td>
            </tr>
          </tbody>
        </table>
        <div v-else>
          <div class="bloc-lot">
            <div class="header">
              Exploitation
            </div>
            <div>
              <RefValue
                :code="lot.numExploitation"
                type="EXPLOITATION"
              />
            </div>
          </div>
          <div class="bloc-lot">
            <div class="header">
              Batiment
            </div>
            <div>
              {{ lot.numBatiment }}
            </div>
          </div>
          <div class="bloc-lot">
            <div class="header">
              Lot
            </div>
            <div>
              {{ lot.numLot }}
            </div>
          </div>
          <div class="bloc-lot">
            <div class="header">
              Date de mise en place
            </div>
            <div>
              {{ lot.dateMep | date }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "~vuetify/src/styles/settings/_variables";

.selection,
.selected {
  font-size: 0.8em;
}

.header {
  text-transform: uppercase;
  text-align: left;
  font-weight: normal;
  color: var(--v-secondary-base);
}

.bloc-lot {
  padding: 0 1em 0 1em;
}

.line {
  font-weight: 500;
}

.list-lots {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0 1em;
  .header {
    padding: 0 1.5em;
  }

  tbody {
    tr {
      box-shadow: 3px 3px 10px lightgrey;
    }
    td {
      padding: 0.5em 1.5em;
      background-color: white;
      background-clip: padding-box;
    }
  }

  .pad-top td {
    border-top: 2em solid transparent;
  }
}

.selected-lot {
  min-width: 80%;
  flex: 1;
  & > table {
    // desktop
    th {
      text-transform: uppercase;
      text-align: left;
      font-weight: normal;
      color: var(--v-secondary-base);
      padding: 0 0.5em;
    }
    td {
      padding: 0 0.5em;
    }
  }

  & > div {
    // mobile
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    .header {
      margin-top: 1em;
    }
    & > *:not(:last-child) {
      margin-right: 1em;
    }
  }
}

.selected > div {
  align-items: center;
}

.liste-lots-mobile {
  .v-card {
    margin: 1em 0;
  }
  .card-row {
    padding: 0.5em;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;

    & > div {
      display: flex;
      flex-direction: column;

      &:not(:last-child) {
        padding-right: 1em;
      }
    }
  }
}
</style>
